import React, {useEffect, useState} from 'react';
import { Flex} from "antd";
import {StyledCard} from "./GuaranteeCard.styled";
import style from "./GuaranteeCard.module.scss";
import {FaChevronLeft} from "react-icons/fa6";
import GuaranteePopup from "../guaranteePopup/GuaranteePopup";
import {GuaranteeCardProps} from "../../models";
import {useLocation} from "react-router-dom";
const GuaranteeCard = ({onConfirm}:GuaranteeCardProps) => {
    const [open, setOpen] = useState<boolean>(false)
    const [chosenItems, setChosenItems] = useState<any>([])
    const location = useLocation();
    const openGuaranteeModal = () => {
        setOpen(true)
    }
    const onCansel = () => {
        setOpen(false)
    }
    useEffect(() => {
        if (location?.state?.stepTwoForm?.productAssurances)
            setChosenItems(location?.state?.stepTwoForm?.productAssurances)
    }, [location]);
    return (
    <>        <StyledCard className={'shadow-sm'} onClick={openGuaranteeModal}  >
            <Flex justify={"space-between"} align={"center"}>
                <Flex align={"center"} gap={"small"}>
                   <span>تضامین</span>
                </Flex>
                <Flex gap={"small"} align={"center"}>
                    {chosenItems?.length > 0  && <span className={style.icons}>{chosenItems?.length} مورد انتخاب شده </span>}
                    <span> <FaChevronLeft  className={style.icons}/> </span>
                </Flex>

            </Flex>
        </StyledCard>
        <GuaranteePopup open={open} onCansel={onCansel} onConfirm={(form:any) =>{
            onConfirm(form)
            setChosenItems(form)
        }}/>
    </>

);
};

export default GuaranteeCard;
